import React from 'react';
import { Phone, MapPin, Clock, Instagram, Facebook } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: 'Início', id: 'hero' },
    { label: 'Sobre', id: 'about' },
    { label: 'Serviços', id: 'services' },
    { label: 'Galeria', id: 'gallery' },
    { label: 'Contato', id: 'location' },
  ];

  const services = [
    'Envidraçamento de Sacadas',
    'Box para Banheiro',
    'Espelhos',
    'Portas e Divisórias',
    'Projetos Personalizados',
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[var(--text-primary)] text-white">
      {/* Main Footer */}
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <img
              src="/assets/images/logo-white.png"
              alt="Forti Vidros"
              className="h-10 w-auto mb-6"
            />
            <p className="text-white/70 mb-6 leading-relaxed">
              Mais de 20 anos transformando ambientes com qualidade e sofisticação em Sorocaba.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/forti.vidros/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-[var(--accent-gold)] rounded-full flex items-center justify-center transition-colors"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://www.facebook.com/FortiVidracaria"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-[var(--accent-gold)] rounded-full flex items-center justify-center transition-colors"
              >
                <Facebook size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Links Rápidos</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-white/70 hover:text-[var(--accent-gold)] transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Serviços</h3>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index} className="text-white/70">
                  {service}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Contato</h3>
            <ul className="space-y-4">
              <li className="flex gap-3">
                <MapPin size={20} className="text-[var(--accent-gold)] flex-shrink-0 mt-1" />
                <span className="text-white/70">
                  R. Dr. Américo Figueiredo, 4980<br />
                  Santa Bárbara - Sorocaba - SP
                </span>
              </li>
              <li className="flex gap-3">
                <Phone size={20} className="text-[var(--accent-gold)] flex-shrink-0" />
                <a
                  href="https://wa.me/5515991253527"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/70 hover:text-[var(--accent-gold)] transition-colors"
                >
                  (15) 99125-3527
                </a>
              </li>
              <li className="flex gap-3">
                <Clock size={20} className="text-[var(--accent-gold)] flex-shrink-0 mt-1" />
                <span className="text-white/70">
                  Seg-Sex: 9h - 17h
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-white/10">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/50 text-sm">
              © {currentYear} Forti Vidros. Todos os direitos reservados.
            </p>
            <p className="text-white/50 text-sm">
              Site: <a href="https://fortividros.com.br" className="hover:text-[var(--accent-gold)] transition-colors">fortividros.com.br</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
